import ProductsSelectionPage from './ProductsSelectionPage'

export default ProductsSelectionPage
